/* eslint-disable */
import Box from '@mui/material/Box'
import { useLocalStorage } from '@/hooks/common'
import { useState } from 'react'
import { styled } from '@mui/material/styles'
import { Input } from '@/components'
import { AccountCircleOutlined, MoreVert, SearchOutlined } from '@mui/icons-material'
import {
  useTheme,
  Button,
  Tabs,
  Tab,
  Toolbar,
  useMediaQuery,
  MenuItem,
  Select,
  SelectChangeEvent,
  IconButton,
  Menu,
  Typography,
} from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { IMAGES } from '@/assets/images'
import { GuestTabs } from '@/utils/constants'
import colors from '@/styles/colors'
import { SVGS } from '@/assets/svgs'
import SVG from 'react-inlinesvg'
import FullLogo from '@/assets/svgs/full-logo.svg'

export const Header = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  backgroundColor: 'white',
  borderBottom: '1px solid rgba(0, 0, 0, 0.06)',
  boxShadow: '0 1px 2px rgba(0, 0, 0, 0.03)',
  minHeight: '72px',
  position: 'sticky',
  top: 0,
  zIndex: 1000,
  backdropFilter: 'blur(8px)',
  transition: 'all 0.2s ease',
}))

export const ButtonSignUp = styled(Button)(({ theme }) => ({
  backgroundColor: '#6366f1',
  color: 'white',
  fontSize: '15px',
  fontWeight: 600,
  borderRadius: '12px',
  height: '44px',
  alignItems: 'center',
  padding: '0px 28px',
  textTransform: 'none',
  boxShadow: '0 1px 2px rgba(99, 102, 241, 0.2)',
  opacity: '1 !important',
  letterSpacing: '-0.01em',
  transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
  '&:hover': {
    backgroundColor: '#5b52d9',
    boxShadow: '0 4px 12px rgba(99, 102, 241, 0.3)',
    transform: 'translateY(-1px)',
    opacity: '1 !important',
  },
  '&:active': {
    transform: 'translateY(0px)',
  },
  '& .MuiTouchRipple-root': {
    display: 'none',
  },
}))

export const ButtonLogin = styled(Button)(({ theme }) => ({
  backgroundColor: 'transparent',
  color: '#1a1a1a',
  fontSize: '15px',
  fontWeight: 600,
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: '#e5e7eb',
  borderRadius: '12px',
  height: '44px',
  alignItems: 'center',
  padding: '0px 28px',
  textTransform: 'none',
  boxShadow: 'none',
  opacity: '1 !important',
  letterSpacing: '-0.01em',
  transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
  '&:hover': {
    backgroundColor: '#fafbfc',
    borderColor: '#6366f1',
    color: '#6366f1',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
    transform: 'translateY(-1px)',
    opacity: '1 !important',
  },
  '&:active': {
    transform: 'translateY(0px)',
  },
  '& .MuiTouchRipple-root': {
    display: 'none',
  },
}))

export const Divider = styled(Box)(() => ({
  height: '100%',
  width: '1px',
  backgroundColor: '#E7EDF3',
}))

interface GuestLandingHeaderProps {
  selectedTabIndex: number
  setSelectedTabIndex: (value: number) => void
}

export default function GuestLandingHeader({
  selectedTabIndex,
  setSelectedTabIndex,
}: GuestLandingHeaderProps) {
  const [searchText, setSearchText] = useState('')
  const [ewUser] = useLocalStorage('ewUser', null)
  const [anchorElNav, setAnchorElNav] = useState<null | HTMLElement>(null)
  const theme = useTheme()
  const lessThanMedium = useMediaQuery(theme.breakpoints.down('md'))
  const navigate = useNavigate()

  const onClickLogin = () => {
    navigate('/login')
  }

  const onClickSignUp = () => {
    navigate(`/signup`)
  }

  const onChangeSearchText = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value)
  }

  const onSearch = () => {
    navigate(`/search?key=${searchText}`)
  }

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (event.key === 'Enter') {
      navigate(`/search?key=${searchText}`)
    }
  }

  const onTabChange = (event: React.SyntheticEvent, value: any) => {
    setSelectedTabIndex(value)
  }

  const onDropdownSelect = (event: SelectChangeEvent) => {
    const value = event.target.value
    setSelectedTabIndex(GuestTabs.indexOf(value))
  }

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget)
  }

  const handleCloseNavMenu = () => {
    setAnchorElNav(null)
  }

  return (
    <>
      <Header>
        <Toolbar
          sx={{
            flex: 1,
            minHeight: '72px !important',
            padding: { xs: '0 16px', md: '0 32px', lg: '0 48px' },
          }}
        >
          {/* Logo - Larger and more prominent */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer',
              transition: 'opacity 0.2s ease',
              '&:hover': {
                opacity: 0.8,
              },
            }}
            onClick={() => navigate('/')}
          >
            <SVG
              src={FullLogo}
              width={lessThanMedium ? 140 : 180}
              height={lessThanMedium ? 32 : 42}
              color='black'
              style={{ display: 'block' }}
            />
          </Box>

          {/* Navigation - Centered with better spacing */}
          {/* <Box
            display={'flex'}
            flexDirection={'row'}
            justifyContent={'center'}
            flex={1}
            sx={{ mx: { md: 4, lg: 6 } }}
          >
            {lessThanMedium && (
              <Select
                value={`${GuestTabs[selectedTabIndex]}`}
                onChange={onDropdownSelect}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                sx={{
                  height: 40,
                  borderRadius: '10px',
                  color: '#1a1a1a',
                  border: '1px solid #e5e7eb',
                  width: '140px',
                  display: 'flex',
                  alignItems: 'center',
                  fontSize: '15px',
                  fontWeight: 500,
                  '& .MuiOutlinedInput-notchedOutline': {
                    border: 'none',
                  },
                  '&:hover': {
                    backgroundColor: '#fafbfc',
                    borderColor: '#d1d5db',
                  },
                }}
              >
                {GuestTabs.map((item, index) => (
                  <MenuItem
                    key={`${index}`}
                    value={`${item}`}
                    sx={{
                      fontSize: '15px',
                      fontWeight: 500,
                      py: 1.5,
                    }}
                  >
                    {GuestTabs[index]}
                  </MenuItem>
                ))}
              </Select>
            )}
            {!lessThanMedium && (
              <Tabs
                value={selectedTabIndex}
                onChange={onTabChange}
                TabIndicatorProps={{
                  style: {
                    height: '3px',
                    borderRadius: '3px 3px 0 0',
                    backgroundColor: '#6366f1',
                  },
                }}
                sx={{
                  '& .MuiTabs-flexContainer': {
                    gap: '8px',
                  },
                }}
              >
                {GuestTabs.map((item, index) => (
                  <Tab
                    key={`${index}`}
                    label={item}
                    sx={{
                      textTransform: 'none',
                      color: '#64748b',
                      fontSize: '15px',
                      fontWeight: 500,
                      minHeight: '72px',
                      padding: '0 20px',
                      letterSpacing: '-0.01em',
                      transition: 'all 0.2s ease',
                      '&:hover': {
                        color: '#1a1a1a',
                        backgroundColor: 'rgba(0, 0, 0, 0.02)',
                      },
                      '&.Mui-selected': {
                        color: '#1a1a1a',
                        fontWeight: 600,
                      },
                    }}
                  />
                ))}
              </Tabs>
            )}
          </Box> */}

          {/* Search Bar - Perfect Stripe-level states */}
          <Box
            sx={{
              flex: 1,
              display: 'flex',
              justifyContent: 'flex-end',
              pr: { xs: 1, md: 2 },
              // maxWidth: '420px',
            }}
          >
            <Input
              value={searchText}
              placeholder='Search designs, patterns...'
              leftIcon={
                <SearchOutlined
                  sx={{
                    fontSize: '20px',
                    transition: 'color 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                  }}
                />
              }
              onChange={onChangeSearchText}
              name='search'
              sx={{
                // Override default Input component styles
                backgroundColor: '#fafbfc !important',
                border: '1.5px solid #e5e7eb !important',
                borderRadius: '12px !important',
                padding: '10px 16px !important',
                fontSize: '15px',
                fontWeight: 400,
                height: '44px',
                transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',

                // Default state
                '&:not(.Mui-focused):not(:hover)': {
                  '& .MuiInputAdornment-root svg': {
                    color: '#9ca3af',
                  },
                },

                // Hover state - subtle lift
                '&:hover:not(.Mui-focused)': {
                  backgroundColor: '#f3f4f6 !important',
                  borderColor: '#d1d5db !important',
                  boxShadow: '0 1px 2px rgba(0, 0, 0, 0.04)',
                  transform: 'translateY(-0.5px)',
                  '& .MuiInputAdornment-root svg': {
                    color: '#6b7280',
                  },
                },

                // Focus state - brand color, white background
                '&.Mui-focused': {
                  backgroundColor: '#ffffff !important',
                  borderColor: '#6366f1 !important',
                  borderWidth: '2px !important',
                  padding: '9px 15px !important', // Compensate for thicker border
                  boxShadow:
                    '0 0 0 3px rgba(99, 102, 241, 0.1), 0 1px 3px rgba(0, 0, 0, 0.1) !important',
                  transform: 'translateY(0px)',
                  '& .MuiInputAdornment-root svg': {
                    color: '#6366f1',
                  },
                },

                // Input field itself
                '& .MuiInputBase-input': {
                  padding: '0 0 0 8px !important',
                  fontSize: '15px',
                  fontWeight: 400,
                  lineHeight: '1.5',
                  color: '#0f172a',
                  letterSpacing: '-0.01em',

                  // Placeholder styling
                  '&::placeholder': {
                    color: '#9ca3af',
                    opacity: 1,
                    fontSize: '15px',
                    fontWeight: 400,
                    transition: 'opacity 0.2s ease',
                  },

                  // Selection color
                  '&::selection': {
                    backgroundColor: 'rgba(99, 102, 241, 0.2)',
                    color: '#0f172a',
                  },
                },

                // Icon container
                '& .MuiInputAdornment-root': {
                  marginRight: '4px',

                  '& svg': {
                    fontSize: '20px',
                    transition: 'color 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                  },
                },
              }}
              onToggleIcon={onSearch}
              onKeyDown={handleKeyDown}
            />
          </Box>

          {/* Mobile Menu */}
          {lessThanMedium && (
            <>
              {/* <Box sx={{ flex: 1 }} /> */}
              <IconButton
                size='large'
                aria-label='account of current user'
                aria-controls='menu-appbar'
                aria-haspopup='true'
                onClick={handleOpenNavMenu}
                color='inherit'
                sx={{
                  ml: 1,
                  justifyContent: 'flex-end',
                  '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                  },
                }}
              >
                <SVG
                  src={SVGS.AccountCircleOutline}
                  width={'24px'}
                  height={'24px'}
                  color={colors.themeBlueIconColor}
                />
              </IconButton>
              <Menu
                id='menu-appbar'
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{
                  display: { xs: 'block', md: 'none' },
                  '& .MuiPaper-root': {
                    borderRadius: '12px',
                    mt: 1,
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
                    minWidth: '160px',
                  },
                }}
              >
                <MenuItem
                  onClick={onClickSignUp}
                  sx={{
                    py: 1.5,
                    px: 3,
                    fontSize: '15px',
                    fontWeight: 500,
                  }}
                >
                  <Typography variant={'p'} textAlign='center'>
                    Sign Up
                  </Typography>
                </MenuItem>

                <MenuItem
                  onClick={onClickLogin}
                  sx={{
                    py: 1.5,
                    px: 3,
                    fontSize: '15px',
                    fontWeight: 500,
                  }}
                >
                  <Typography variant={'p'} textAlign='center'>
                    Login
                  </Typography>
                </MenuItem>
              </Menu>
            </>
          )}

          {/* Desktop Auth Buttons */}
          {!lessThanMedium && (
            <Box
              display='flex'
              flexDirection={'row'}
              justifyContent={'flex-end'}
              flex={1}
              gap={2}
              sx={{ ml: 1 }}
            >
              <ButtonLogin variant={'outlined'} onClick={onClickLogin}>
                Login
              </ButtonLogin>
              <ButtonSignUp onClick={onClickSignUp}>Sign Up</ButtonSignUp>
            </Box>
          )}
        </Toolbar>
      </Header>
    </>
  )
}
